import Button, { ButtonVariant } from "./Button";
import Modal from "./Modal";

export interface ConfirmDialogAction {
  label: string;
  variant?: ButtonVariant;
  onClick: () => void;
}

interface ConfirmDialogProps {
  open: boolean;
  title?: string | null;
  message: string;
  actions: ConfirmDialogAction[];
  // 바깥 클릭 · ESC 로 닫을 때 호출. 없으면 닫을 수 없다.
  onClose?: () => void;
  // 버튼이 길거나 3개 이상이면 세로로 쌓는다
  vertical?: boolean;
}

// 확인 · 경고 다이얼로그. 짧은 질문이므로 모바일에서도 가운데에 띄운다.
export default function ConfirmDialog({
  open,
  title,
  message,
  actions,
  onClose,
  vertical,
}: ConfirmDialogProps) {
  const stacked = vertical ?? actions.length > 2;

  return (
    <Modal
      open={open}
      onClose={() => onClose?.()}
      dismissible={onClose !== undefined}
      placement="center"
      size="sm"
      title={title ?? undefined}
      description={message}
      footer={
        <div
          style={{
            display: "flex",
            flexDirection: stacked ? "column" : "row",
            gap: 8,
            width: "100%",
          }}
        >
          {actions.map((action, index) => (
            <Button
              key={index}
              variant={action.variant ?? "outline"}
              size="lg"
              fullWidth={stacked}
              style={stacked ? undefined : { flex: "1 1 0", minWidth: 0 }}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      }
    />
  );
}
